import React, { createElement, useMemo } from "react";
import { useEffect, useState } from "react";
import { BlockViewer } from "../../BlockViewer.js";
import { getBlock } from "../../registerBlock.js";
/**
 * Load the matching Smartfire block for the given node
 * @param node The BlockEngineNode to load the block for
 * @returns loading state, the block, the block props, and an error if one occurred
 */
function useBlockViewer(node) {
    const [blockViewer, setBlockViewer] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const componentName = node.componentName;
        if (!componentName) {
            setError(new Error("No component name"));
            setBlockViewer(null);
            return;
        }
        // Call the block engine to get the block
        getBlock(componentName)
            // Resolution is async because it may need to load the block from the server
            .then((block) => {
            setBlockViewer(() => block);
        })
            // If the block is not found, throw an error
            .catch((err) => {
            setError(err);
        });
    }, [node.componentName]);
    return {
        // Only show the block viewer if the block has been loaded
        loading: !blockViewer && !error,
        blockViewer,
        error
    };
}
/**
 * Display a block node using the matching Smartfire block
 * @param props Node to display
 */
export const BlockNode = (props) => {
    const { node } = props;
    const { loading, blockViewer, error } = useBlockViewer(node);
    // Memoize the block viewer so we avoid re-rendering the block when the node changes
    const Viewer = useMemo(() => {
        if (!blockViewer)
            return null;
        return BlockViewer({
            block: blockViewer,
            children: node.childrenAsReactElements(),
            frontend: {
                node,
            }
        });
    }, [blockViewer, node]);
    if (loading) {
        return React.createElement(React.Fragment, null);
    }
    if (error) {
        throw error;
    }
    if (!Viewer) {
        return React.createElement(React.Fragment, null);
    }
    return createElement(Viewer, node.componentProps);
};

//# sourceMappingURL=BlockNode.js.map
